{
  "decrease": "Diminuer {fieldLabel}",
  "increase": "Augmenter {fieldLabel}",
  "numberField": "Champ de nombre"
}
